import React, { ReactNode } from "react";
import styled from "styles/styled_components";

import { getHighestRoleCategory, getRoleLabel } from "helpers/schedule/roles";
import { IPerson } from "types/schedules";

import CategoryFlag from "components/schedule/category_flag";
import { StyledRole } from "components/schedule/time_block";
import ellipsis from "styles/ellipsis";

const StyledWrapper = styled.div`
  min-height: ${props => props.theme.rawShiftHeight}px;
  /* Fill available space */
  position: absolute;
  bottom: 0;
  height: auto;
  left: 0;
  right: 0;
  top: 0;
`;

const StyledAssigneeWrapper = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  line-height: ${props => props.theme.text.lineHeight.base};
  padding-left: ${({ theme }) => theme.spacing.small};
  padding-top: 1px;
  position: absolute;

  & span {
    display: block;
  }
`;

const StyledAssigneeName = styled.span`
  color: ${props => props.theme.colors.lspdBlue500};
  display: block;
  ${ellipsis}
`;

interface IPersonCell {
  person: IPerson;
  shiftsTotalHours: ReactNode;
}

export default function PersonCell({ person, shiftsTotalHours }: IPersonCell) {
  return person.assignee.match({
    Just: assignee => {
      const employeeName = `${assignee.firstName} ${assignee.lastName}`;
      const roleLabel = getRoleLabel(assignee);
      return (
        <StyledWrapper title={`${employeeName}: ${roleLabel}`}>
          <CategoryFlag category={getHighestRoleCategory(assignee)} vertical />
          <StyledAssigneeWrapper>
            <StyledAssigneeName>{employeeName}</StyledAssigneeName>
            <StyledRole>{roleLabel}</StyledRole>
            {shiftsTotalHours}
          </StyledAssigneeWrapper>
        </StyledWrapper>
      );
    },
    Nothing: () => (
      <StyledWrapper>
        <CategoryFlag category="Unassigned" vertical />
        <StyledAssigneeWrapper>
          <StyledRole>
            Unassigned
            <br />
            Shifts
          </StyledRole>
        </StyledAssigneeWrapper>
      </StyledWrapper>
    ),
  });
}
